import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { ZapIcon } from 'lucide-react';
const data = [{
  time: '00:00',
  kwh: 0.8
}, {
  time: '03:00',
  kwh: 0.6
}, {
  time: '06:00',
  kwh: 1.2
}, {
  time: '09:00',
  kwh: 2.8
}, {
  time: '12:00',
  kwh: 3.5
}, {
  time: '15:00',
  kwh: 3.2
}, {
  time: '18:00',
  kwh: 2.9
}, {
  time: '21:00',
  kwh: 1.5
}, {
  time: '23:59',
  kwh: 1.0
}];
export function EnergyChart() {
  return <div className="glass-panel rounded-2xl p-4 flex flex-col flex-1 h-full" data-id="element-60">
      <div className="flex items-center justify-between mb-2" data-id="element-61">
        <div className="flex items-center space-x-2 text-slate-400" data-id="element-62">
          <ZapIcon className="w-4 h-4 text-amber-400" data-id="element-63" />
          <span className="text-[11px] font-medium uppercase tracking-wider" data-id="element-64">
            오늘의 에너지 사용량
          </span>
        </div>
        <span className="text-lg font-mono font-bold text-white glow-text-amber" data-id="element-65">
          2.4 <span className="text-xs text-slate-500 font-normal" data-id="element-66">kWh</span>
        </span>
      </div>

      <div className="w-full flex-1 min-h-0" data-id="element-67">
        <ResponsiveContainer width="100%" height="100%" data-id="element-68">
          <AreaChart data={data} data-id="element-69">
            <defs data-id="element-70">
              <linearGradient id="colorKwh" x1="0" y1="0" x2="0" y2="1" data-id="element-71">
                <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.3} data-id="element-72" />
                <stop offset="95%" stopColor="#f59e0b" stopOpacity={0} data-id="element-73" />
              </linearGradient>
            </defs>
            <XAxis dataKey="time" axisLine={false} tickLine={false} tick={{
            fill: '#64748b',
            fontSize: 9,
            fontFamily: 'JetBrains Mono'
          }} interval={2} data-id="element-74" />
            <YAxis hide data-id="element-75" />
            <Tooltip contentStyle={{
            backgroundColor: '#0a0f1a',
            borderColor: 'rgba(255,255,255,0.1)',
            borderRadius: '8px',
            fontFamily: 'JetBrains Mono',
            fontSize: 11
          }} itemStyle={{
            color: '#f59e0b'
          }} data-id="element-76" />
            <Area type="monotone" dataKey="kwh" stroke="#f59e0b" strokeWidth={2} fillOpacity={1} fill="url(#colorKwh)" data-id="element-77" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>;
}